export const ANTICHESS = 'Antichess';
export const GRID_CHESS = 'Gridchess';
export const EXTINCTION_CHESS = 'Extinction';
export const STANDARD_CHESS = 'Standard';
export const STANDARD_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
